import Link from "next/link";
import { useSelector } from "react-redux";

import { useStoreContext } from "@components/store/provider";
import { useCheckoutContext } from "@contexts/checkout-context";

import Multimedia from "@sharedComponents/multimedia";

import { getReceivedItemsCount } from "@selectors/cart";

import { getCartRoute } from "@constants/routes";

import giftItems from "@images/svg/giftItems.svg";

import style from "./main.module.scss";

const SelectedItemsCount = () => {
  const receivedItemsCount = useSelector(getReceivedItemsCount);
  const { cartItemsQuantity } = useCheckoutContext();
  const { storeBasePath } = useStoreContext();

  if (receivedItemsCount < 1) return null;
  return (
    <Link
      href={getCartRoute({ storeBasePath })}
      className={style.giftItems}
      prefetch={false}
      title="cart"
    >
      <Multimedia
        src={giftItems}
        alt="item box"
        type="image"
        height="32"
        width="32"
        className={style.giftImage}
      />
      <div className={style.textInfo}>
        {cartItemsQuantity}/{receivedItemsCount} ITEMS
      </div>
    </Link>
  );
};

export default SelectedItemsCount;
